export default {
  $getFormatDate(timestamp = new Date, type) {
    let date = new Date(timestamp),
      year = date.getFullYear(),
      month = this.$formatDateDigits(date.getMonth() + 1),
      day = this.$formatDateDigits(date.getDate());

    switch (type) {
      case 1:
        return `${year}年${month}月${day}日`;
      case 2:
        return `${year}/${month}/${day}`;
      case 3:
        return `${year}-${month}-${day}`;
      default:
        return `${year}-${month}-${day}`;
    }
  },

  $getFormatTime(timestamp = new Date) {
    let date = new Date(timestamp),
      h = this.$formatDateDigits(date.getHours()),
      m = this.$formatDateDigits(date.getMinutes()),
      s = this.$formatDateDigits(date.getSeconds());

    return `${h}:${m}:${s}`;
  },

  $formatDateDigits(number) {
    if (typeof number !== "number") return -1;
    return number < 10 ? "0" + number : String(number);
  },

  downloadFile(options) {
    const { filedata, filename } = options
    console.log(options, 123);
    const blob = new Blob([filedata])

    var elink = document.createElement('a')
    console.log(elink, '333');
    elink.download = `${filename}.xlsx`
    elink.style.display = 'none'

    elink.href = window.URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    document.body.removeChild(elink)
  }
}